<template>
    <div>
        <table class="table">
            <tbody>
                <app-list-deals-item v-for="item in list" :item="item"></app-list-deals-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListDealsItem from './ListDealsItem'
  import data from '../../data/products'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListDealsItem: ListDealsItem
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
</style>

